import React from 'react';
import './InfoCard.css';

const InfoCard = ({ title, description, image }) => {
  return (
    <div className="info-card">
      {image && <img src={image} alt={title} className="info-card-img" />}
      <div className="info-card-content">
        <h3 className="info-card-title">{title}</h3>
        <p className="info-card-description">{description}</p>
      </div>
    </div>
  );
};

export default InfoCard; 